import { PlusIcon } from '@heroicons/react/solid';
import { memo } from 'react';

import { Button, Card, CardSection, Text } from '@/lib/v2/components';

import { PlayVideo } from '@/src/modules/AutomationModuleNew/components/PlayVideo';

type CTACardProps = {
  title: string;
  description: string | JSX.Element;
  buttonText: string;
  linkText: string;
  onClickButton?: () => void;
  videoUrl?: string;
  portraitImage?: string;
  linkUrl?: string;
};

const CTACard = ({
  title,
  description,
  buttonText,
  onClickButton,
  portraitImage,
  videoUrl,
  linkText,
  linkUrl,
}: CTACardProps) => {
  return (
    <Card>
      <CardSection paddingX="extraLarge" paddingY="large">
        <div className="grid gap-4 sm:grid-cols-2 sm:flex-row lg:gap-24">
          <div className="flex w-full flex-col justify-center gap-6 lg:pr-24">
            <div className="flex flex-col gap-4">
              <Text color="primary" fontWeight="medium" variant="title-2">
                {title}
              </Text>
              <Text>{description}</Text>
              <Button
                secondary
                standard
                iconLeft={<PlusIcon className="size-5" />}
                onClick={onClickButton}
              >
                {buttonText}
              </Button>
            </div>
            <Text link color="primary" href={linkUrl} target="_blank" variant="text-sm">
              {linkText}
            </Text>
          </div>
          <div className="flex w-full justify-end">
            <div className="w-full xl:w-[70%]">
              <PlayVideo portraitImage={portraitImage} videoUrl={videoUrl} />
            </div>
          </div>
        </div>
      </CardSection>
    </Card>
  );
};

export default memo(CTACard);
